import { FlexColumn } from '@gorila-shared-ui/components';
import { Filter } from 'baseui/table';
import { memo } from 'react';
import { useStyles } from '../../../hooks/useStyles';
import { BrandSelect } from '../../shared/BrandSelect';
import { SubBrandSelect } from '../../shared/SubBrandSelect';
import { useFleetAssets } from '../hooks/useFleetAssets';
import { MultipleFleetAssetTypeSelect } from '../shared/MultipleFleetAssetTypeSelect';

export function FleetAssetsFilters() {
  const { theme, css, overrides } = useStyles();
  const { filters, hasActiveFilters, resetFilters, onChangeFilter } = useFleetAssets();

  return (
    <Filter
      active={hasActiveFilters}
      overrides={overrides.filtersOverrides(resetFilters)}
    >
      <FlexColumn
        classNames={css({
          paddingTop: theme.sizing.scale500,
          paddingBottom: theme.sizing.scale500,
        })}
        gap={theme.sizing.scale200}
      >
        <MultipleFleetAssetTypeSelect
          label="Tipo:"
          onTypesChange={(assetTypes) => {
            onChangeFilter('assetTypes', assetTypes);
          }}
          assetTypes={filters.assetTypes}
          placeholder="Selecciona tipos de activo"
          inline
        />
        <BrandSelect
          inline
          showEmptyOption
          isFilter
          selectedBrandId={filters.brandId}
          onChangeBrandId={(brandId) => {
            onChangeFilter('brandId', brandId);
          }}
        />
        <SubBrandSelect
          inline
          showEmptyOption
          isFilter
          selectedBrandId={filters.brandId}
          selectedSubBrandId={filters.subBrandId}
          onChangeSubBrand={(subBrandId) => {
            onChangeFilter('subBrandId', subBrandId);
          }}
        />
      </FlexColumn>
    </Filter>
  );
}

export default memo(FleetAssetsFilters);
